/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Store_TitleInputs */

const en_bot_store_title = /** @type {(inputs: Bot_Store_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is kept`)
};

const id_bot_store_title = /** @type {(inputs: Bot_Store_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang disimpan`)
};

/**
* | output |
* | --- |
* | "What is kept" |
*
* @param {Bot_Store_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_store_title = /** @type {((inputs?: Bot_Store_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Store_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_store_title(inputs)
	return en_bot_store_title(inputs)
});